<template>
  <div class="l-page l-page--detail">
    <div
      v-if="!dialogMode"
      class="l-page__header c-page__header"
    >
      <h2 class="c-page__header-title">
        新增维保计划
      </h2>
      <div class="c-page__header-btns">
        <k-button
          btn-text="保存"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-save"
          @click="save"
        />
        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        />
      </div>
    </div>
    <div class="l-page__body l-page--detail__body">
      <hm-page-card class="c-card--detail">
        <el-alert
          title="说明：维保合同有效期内才可添加计划"
          type="info"
          :closable="false"
          class="u-mg-b-10"
        />
        <el-form
          ref="form"
          :model="fd"
          :inline="true"
          label-suffix="："
          label-width="120px"
          class="c-form jxxf-plan-form"
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="维保项目"
                required
              >
                <el-select
                  v-model="fd.xmId"
                  :disabled="!!projectId || !!planId"
                  class="c-form__select"
                  filterable
                  placeholder="请选择"
                  @change="handleProjectChange"
                >
                  <el-option
                    v-for="item in projects"
                    :key="item.uuid"
                    :label="item.xmmc"
                    :value="item.uuid"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="合同有效期"
              >
                <span class="c-form__read">{{ contractRangeText }}</span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="计划年份"
                required
              >
                <el-select
                  v-model="fd.jhnf"
                  class="c-form__select"
                  :disabled="!projectDetail.uuid"
                  placeholder="请选择"
                  @change="buildPlanOptions"
                >
                  <el-option
                    v-for="year in yearOptions"
                    :key="year"
                    :label="String(year)"
                    :value="year"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="维保周期"
                required
              >
                <el-checkbox-group
                  v-model="fd.jhlxList"
                  :disabled="!fd.jhnf"
                  @change="buildPlanOptions"
                >
                  <el-checkbox label="YD">
                    月度
                  </el-checkbox>
                  <el-checkbox label="JD">
                    季度
                  </el-checkbox>
                  <el-checkbox label="ND">
                    年度
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="计划名称"
                required
              >
                <span
                  v-if="!fd.jhnf || !fd.jhlxList.length"
                  class="u-text-danger"
                >
                  请先选择计划年份和维保周期
                </span>
                <el-checkbox-group
                  v-else
                  v-model="fd.selectedPlanKeys"
                  class="c-form__checkbox-group"
                >
                  <el-checkbox
                    v-for="item in planOptions"
                    :key="item.key"
                    :label="item.key"
                  >
                    {{ item.jhmc }}
                  </el-checkbox>
                </el-checkbox-group>
                <span
                  v-if="fd.jhnf && fd.jhlxList.length && !planOptions.length"
                  class="u-text-danger"
                >
                  所选年份和周期没有完整处于合同有效期内的计划
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="维保人员"
                required
              >
                <select-xm-user
                  v-model="fd.wbryDmList"
                  class="c-form__select"
                  role-code="JX-WB"
                  :show-dept="false"
                  multiple
                  collapse-tags
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="维保内容系统"
              >
                <el-checkbox-group
                  v-model="facilityIds"
                  class="c-form__checkbox-group"
                  @change="fd.selectedFacilityIds = facilityIds.slice()"
                >
                  <el-checkbox
                    v-for="item in projectFacilities"
                    :key="item.uuid"
                    :label="item.uuid"
                  >
                    {{ item.ssmc }}
                  </el-checkbox>
                </el-checkbox-group>
                <span
                  v-if="fd.xmId && !projectFacilities.length"
                  class="u-text-danger"
                >
                  该项目未配置维保设施系统
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="任务描述"
              >
                <el-input
                  v-model="fd.rwms"
                  class="c-form__input"
                  type="textarea"
                  :rows="3"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
  </div>
</template>

<script>
import { planService } from './plan.service';
import { projectService } from '../project/project.service';

export default {
  name: 'JxxfWbPlanForm',
  props: {
    /** 弹窗模式标志 */
    dialogMode: { type: Boolean, default: false },
    /** 当前项目计划列表传入的项目 ID。 */
    projectId: { type: String, default: '' },
    /** 待编辑的维保计划 ID。 */
    planId: { type: String, default: '' }
  },
  /** 初始化计划创建所需的项目、合同和选择状态。 */
  data () {
    return {
      loading: false,
      projects: [],
      projectDetail: {},
      yearOptions: [],
      planOptions: [],
      projectFacilities: [],
      facilityIds: [],
      fd: {
        xmId: '',
        jhnf: null,
        jhlxList: [],
        selectedPlanKeys: [],
        selectedFacilityIds: [],
        wbryDmList: [],
        rwms: '对各系统进行定期维护保养，测试并出具维保报告。'
      }
    };
  },
  computed: {
    /** 显示当前项目合同有效期。 */
    contractRangeText () {
      if (!this.projectDetail.htyxqQ || !this.projectDetail.htyxqZ) return '-';
      return `${this.formatDate(this.projectDetail.htyxqQ)} 至 ${this.formatDate(this.projectDetail.htyxqZ)}`;
    }
  },
  methods: {
    /** 加载可用于创建计划的江西维保项目。 */
    loadProjects () {
      planService.projects({ pageNo: 1, pageSize: 1000 }).then(rsp => {
        this.projects = rsp.data.rows || [];
      });
    },
    /** 切换项目后加载合同和项目已配置的设施系统。 */
    handleProjectChange () {
      this.projectDetail = {};
      this.yearOptions = [];
      this.planOptions = [];
      this.projectFacilities = [];
      this.facilityIds = [];
      this.fd.selectedFacilityIds = [];
      this.fd.jhnf = null;
      this.fd.jhlxList = [];
      this.fd.selectedPlanKeys = [];
      if (!this.fd.xmId) return;
      this.loading = true;
      return projectService.detail(this.fd.xmId).then(rsp => {
        this.projectDetail = rsp.data || {};
        this.projectFacilities = this.projectDetail.ssflList || [];
        this.facilityIds = this.projectFacilities.map(item => item.uuid);
        this.fd.selectedFacilityIds = this.facilityIds.slice();
        this.yearOptions = this.getContractYears();
        if (!this.yearOptions.length) {
          this.$message.warning('该项目未配置有效合同，不能创建维保计划');
          return;
        }
        const currentYear = new Date().getFullYear();
        this.fd.jhnf = this.yearOptions.indexOf(currentYear) > -1 ? currentYear : this.yearOptions[0];
      }).finally(() => {
        this.loading = false;
      });
    },
    /** 生成合同有效期内可选择的计划年份。 */
    getContractYears () {
      const start = this.toDate(this.projectDetail.htyxqQ);
      const end = this.toDate(this.projectDetail.htyxqZ);
      if (!start || !end || start > end) return [];
      const years = [];
      for (let year = start.getFullYear(); year <= end.getFullYear(); year++) years.push(year);
      return years;
    },
    /** 根据年份和勾选周期生成可选择的维保计划。 */
    buildPlanOptions () {
      this.fd.selectedPlanKeys = [];
      this.planOptions = [];
      if (!this.fd.jhnf || !this.fd.jhlxList.length) return;
      this.fd.jhlxList.forEach(type => {
        if (type === 'YD') this.addMonthlyPlans();
        if (type === 'JD') this.addQuarterlyPlans();
        if (type === 'ND') this.addAnnualPlan();
      });
    },
    /** 生成所选年份的月度计划。 */
    /** 加载待编辑计划并回显项目、人员和内容系统。 */
    loadPlan () {
      return planService.detail(this.planId).then(rsp => {
        const plan = rsp.data || {};
        this.fd.xmId = plan.xmId;
        return this.handleProjectChange().then(() => {
          this.fd.jhnf = plan.jhnf;
          this.fd.jhlxList = [plan.jhlx];
          this.buildPlanOptions();
          this.fd.selectedPlanKeys = [plan.jhlx + '-' + plan.qhbh];
          this.fd.wbryDmList = (plan.ryList || []).map(item => item.ryDm);
          this.facilityIds = plan.ssflIds || [...new Set((plan.nrList || []).map(item => item.ssflId))];
          this.fd.selectedFacilityIds = this.facilityIds.slice();
          this.fd.rwms = plan.rwms || '';
        });
      });
    },
    addMonthlyPlans () {
      for (let month = 0; month < 12; month++) {
        const start = new Date(this.fd.jhnf, month, 1);
        const end = new Date(this.fd.jhnf, month + 1, 0);
        this.addPlanOption('YD', `${this.fd.jhnf}${String(month + 1).padStart(2, '0')}`, `${this.fd.jhnf}年${month + 1}月维保`, start, end);
      }
    },
    /** 生成所选年份的季度计划。 */
    addQuarterlyPlans () {
      for (let quarter = 0; quarter < 4; quarter++) {
        const start = new Date(this.fd.jhnf, quarter * 3, 1);
        const end = new Date(this.fd.jhnf, (quarter + 1) * 3, 0);
        this.addPlanOption('JD', `${this.fd.jhnf}Q${quarter + 1}`, `${this.fd.jhnf}年第${quarter + 1}季度维保`, start, end);
      }
    },
    /** 生成所选年份的年度计划。 */
    addAnnualPlan () {
      this.addPlanOption('ND', String(this.fd.jhnf), `${this.fd.jhnf}年度维保`, new Date(this.fd.jhnf, 0, 1), new Date(this.fd.jhnf, 11, 31));
    },
    /** 仅在执行周期完整处于合同有效期内时加入计划选项。 */
    addPlanOption (jhlx, qhbh, jhmc, start, end) {
      if (!this.isWithinContract(start, end)) return;
      this.planOptions.push({
        key: `${jhlx}-${qhbh}`,
        jhlx,
        qhbh,
        jhmc,
        jhsjQ: this.formatDate(start),
        jhsjZ: this.formatDate(end)
      });
    },
    /** 判断计划执行周期是否完整处于合同有效期内。 */
    isWithinContract (start, end) {
      const contractStart = this.toDate(this.projectDetail.htyxqQ);
      const contractEnd = this.toDate(this.projectDetail.htyxqZ);
      return contractStart && contractEnd && start >= contractStart && end <= contractEnd;
    },
    /** 转换日期字符串或日期对象为本地日期。 */
    toDate (value) {
      if (!value) return null;
      const raw = Number(value);
      const date = value instanceof Date
        ? value
        : Number.isFinite(raw)
          ? new Date(raw < 100000000000 ? raw * 1000 : raw)
          : new Date(String(value).substring(0, 10).replace(/-/g, '/'));
      return isNaN(date.getTime()) ? null : date;
    },
    /** 格式化日期为后端计划接口需要的日期字符串。 */
    formatDate (value) {
      const date = this.toDate(value);
      if (!date) return '-';
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${date.getFullYear()}-${month}-${day}`;
    },
    /** 组装所选计划和多名维保人员的批量保存参数。 */
    buildBatchSaveData () {
      const selected = this.planOptions.filter(item => this.fd.selectedPlanKeys.indexOf(item.key) > -1);
      return {
        planList: selected.map(item => ({
          xmId: this.fd.xmId,
          jhmc: item.jhmc,
          jhlx: item.jhlx,
          jhnf: this.fd.jhnf,
          qhbh: item.qhbh,
          jhsjQ: item.jhsjQ,
          jhsjZ: item.jhsjZ,
          rwms: this.fd.rwms,
          ryList: this.fd.wbryDmList.map(ryDm => ({ ryDm, rylx: 'JX-WB', sfzr: 'N' })),
          ssflIds: this.fd.selectedFacilityIds
        }))
      };
    },
    /** 校验后批量创建用户勾选的维保计划。 */
    save () {
      if (!this.fd.xmId || !this.fd.jhnf || !this.fd.jhlxList.length || !this.fd.selectedPlanKeys.length || !this.fd.wbryDmList.length || !this.fd.selectedFacilityIds.length) {
        this.$message.warning('请完整选择维保项目、年份、周期、计划名称和维保人员');
        return;
      }
      if (this.planId && this.fd.selectedPlanKeys.length !== 1) {
        this.$message.warning('修改维保计划时只能选择一个计划名称');
        return;
      }
      this.loading = true;
      const data = this.buildBatchSaveData();
      const request = this.planId
        ? planService.update(this.planId, data.planList[0])
        : planService.batchCreate(data);
      request.then(() => {
        this.$message.success('维保计划创建成功');
        if (this.dialogMode) this.$emit('saved');
        else this.closeNavTabAndTo({ name: 'jxxfWbPlanIndex' });
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  /** 创建页面时加载可选项目。 */
  created () {
    this.loadProjects();
    if (this.planId) {
      this.loadPlan();
    } else if (this.projectId) {
      this.fd.xmId = this.projectId;
      this.handleProjectChange();
    }
  }
};
</script>

<style lang="scss">
.jxxf-plan-form {
  .c-form__input,
  .c-form__select,
  .el-date-editor {
    width: 100%;
  }
}
</style>
